/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Einverstaendnisbild1Inputs */

const de__field_einverstaendnisbild1 = /** @type {(inputs: _Field_Einverstaendnisbild1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einverständnis Bild`)
};

/**

* @param {_Field_Einverstaendnisbild1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_einverstaendnisbild1 = /** @type {((inputs?: _Field_Einverstaendnisbild1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Einverstaendnisbild1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_einverstaendnisbild1(inputs)
});
export { _field_einverstaendnisbild1 as "_field_einverstaendnisBild" }